import { mdiDotsHorizontal } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'

const DotMenu = (props) => (
    <Icon
        data-testid="IconButton__DotMenu"
        aria-label="Model Menu"
        path={mdiDotsHorizontal}
        size={1}
        {...props}
    />
)

export default React.memo(DotMenu)
